export const GET_COMPANY = 'GET_COMPANY';
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';
export const GET_COMPANY_ERROR = 'GET_COMPANY_ERROR';
export const GET_COMPANY_RESOURCES_SUCCESS = 'GET_COMPANY_RESOURCES_SUCCESS';

export const GENERIC = 'generic';
export const SEIU = 'seiu775srp';
export const VALID_COMPANIES_MY_RETIREMENT = ['rwjbh', GENERIC];
